import React from 'react';
import FormSelect from '../../Songs/components/FormSelect';
import DragDropUpload from '../../Songs/components/DragDropUpload';

function BasicDetailsTab({ 
  song, 
  isEditing,
  editName, setEditName,
  editNameSinhala, setEditNameSinhala,
  editIsrcCode, setEditIsrcCode,
  editOther, setEditOther,
  editOriginalOrVersion, setEditOriginalOrVersion,
  editVersionName, setEditVersionName,
  editOriginalSongId, setEditOriginalSongId,
  editSingers, setEditSingers,
  editLyricists, setEditLyricists,
  editMusicians, setEditMusicians,
  // Main artist for revenue
  editMainSinger, setEditMainSinger,
  editMainLyricist, setEditMainLyricist,
  editMainMusician, setEditMainMusician,
  editDistributionEnabled, setEditDistributionEnabled,
  editSelectedDistribution, setEditSelectedDistribution,
  editRingtoneEnabled, setEditRingtoneEnabled,
  editRingtoneCards, setEditRingtoneCards,
  editTrack, setEditTrack,
  editTrackPreview, setEditTrackPreview,
  distributionOptions,
  ringtoneOptions,
  onDeactivate,
  isSongActive,
  isInactivating
}) {
  if (isEditing) {
    return (
      <div className="in-place-edit-form" style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '10px' }}>
        {/* Track Upload */}
        <DragDropUpload
          label="Song Track (MP3 only)"
          required={true}
          accept=".mp3"
          infoText="Drag & drop your MP3 file here or click to choose"
          value={editTrack ? { name: editTrack.name, size: editTrack.size } : (editTrackPreview ? { name: editTrackPreview.split('/').pop(), size: 0 } : null)}
          onChange={(val) => {
            if (val) {
              setEditTrack(val.file);
              setEditTrackPreview(val.previewUrl);
            } else {
              setEditTrack(null);
              setEditTrackPreview('');
            }
          }}
        />

        {/* Basic Texts */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <div className="form-field-group">
            <label className="form-field-label" style={{ fontWeight: '600', marginBottom: '6px', display: 'block' }}>Song Name <span className="required-asterisk">*</span></label>
            <input type="text" className="form-input-field" value={editName} onChange={e => setEditName(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
          </div>
          <div className="form-field-group">
            <label className="form-field-label" style={{ fontWeight: '600', marginBottom: '6px', display: 'block' }}>Song Name (Sinhala) <span className="required-asterisk">*</span></label>
            <input type="text" className="form-input-field" value={editNameSinhala} onChange={e => setEditNameSinhala(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
          </div>
        </div>

        {/* Role Selects */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <FormSelect
            label="Artist *"
            value={editSingers}
            onChange={(newVal) => {
              setEditSingers(newVal);
              if (editMainSinger && !newVal.map(String).includes(String(editMainSinger))) {
                setEditMainSinger(newVal.length > 0 ? String(newVal[0]) : null);
              }
              if (!editMainSinger && newVal.length > 0) {
                setEditMainSinger(String(newVal[0]));
              }
            }}
            isMulti={true}
            isLazy={true}
            placeholder="Search & select artist(s)"
            mainValue={editMainSinger}
            onMainChange={setEditMainSinger}
          />
          <FormSelect
            label="Lyrics"
            value={editLyricists}
            onChange={(newVal) => {
              setEditLyricists(newVal);
              if (editMainLyricist && !newVal.map(String).includes(String(editMainLyricist))) {
                setEditMainLyricist(newVal.length > 0 ? String(newVal[0]) : null);
              }
              if (!editMainLyricist && newVal.length > 0) {
                setEditMainLyricist(String(newVal[0]));
              }
            }}
            isMulti={true}
            isLazy={true}
            placeholder="Search & select lyricist(s)"
            mainValue={editMainLyricist}
            onMainChange={setEditMainLyricist}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <FormSelect
            label="Music"
            value={editMusicians}
            onChange={(newVal) => {
              setEditMusicians(newVal);
              if (editMainMusician && !newVal.map(String).includes(String(editMainMusician))) {
                setEditMainMusician(newVal.length > 0 ? String(newVal[0]) : null);
              }
              if (!editMainMusician && newVal.length > 0) {
                setEditMainMusician(String(newVal[0]));
              }
            }}
            isMulti={true}
            isLazy={true}
            placeholder="Search & select music composer(s)"
            mainValue={editMainMusician}
            onMainChange={setEditMainMusician}
          />
          <div className="form-field-group">
            <label className="form-field-label" style={{ fontWeight: '600', marginBottom: '6px', display: 'block' }}>ISRC Code <span className="required-asterisk">*</span></label>
            <input type="text" className="form-input-field" value={editIsrcCode} onChange={e => setEditIsrcCode(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
          </div>
        </div>

        {/* Description / Other Details */}
        <div className="form-field-group">
          <label className="form-field-label" style={{ fontWeight: '600', marginBottom: '6px', display: 'block' }}>Other Details</label>
          <textarea className="form-textarea-field" value={editOther} onChange={e => setEditOther(e.target.value)} rows={3} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', resize: 'vertical' }} />
        </div>

        {/* Version Details */}
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div className="form-field-group">
              <label className="form-field-label" style={{ fontWeight: '600', marginBottom: '6px', display: 'block' }}>Original or Versions *</label>
              <select className="form-select-field" value={editOriginalOrVersion} onChange={e => setEditOriginalOrVersion(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', backgroundColor: '#fff' }}>
                <option value="Original">Original</option>
                <option value="Version">Version</option>
              </select>
            </div>
            {editOriginalOrVersion === 'Version' && (
              <div className="form-field-group">
                <label className="form-field-label" style={{ fontWeight: '600', marginBottom: '6px', display: 'block' }}>Version Name *</label>
                <input type="text" className="form-input-field" value={editVersionName} onChange={e => setEditVersionName(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }} />
              </div>
            )}
          </div>
          {editOriginalOrVersion === 'Version' && (
            <div style={{ marginTop: '20px' }}>
              <FormSelect
                label="Original Song Name *"
                value={editOriginalSongId}
                onChange={setEditOriginalSongId}
                isMulti={false}
                placeholder="Search & select original song"
                isLazy={true}
                lazyType="songs"
                lazyParams={{ versionType: 'Original', ...(song?.id ? { excludeId: song.id } : {}) }}
              />
            </div>
          )}
        </div>

        {/* Distribution Settings */}
        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
          <div className="toggle-section-wrapper" style={{ marginBottom: '15px' }}>
            <label className="checkbox-toggle-switch" style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
              <input type="checkbox" checked={editDistributionEnabled} onChange={e => setEditDistributionEnabled(e.target.checked)} />
              <span className="toggle-label-text" style={{ fontWeight: '600' }}>Distribution Settings</span>
            </label>
          </div>
          {editDistributionEnabled && (
            <FormSelect
              label="Distribution Provider"
              value={editSelectedDistribution}
              onChange={setEditSelectedDistribution}
              isMulti={false}
              placeholder="Search and select one"
              options={distributionOptions}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="info-rows-list">
      {/* Artist row */}
      <div className="info-row">
        <div className="info-icon-wrapper">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <span className="info-label">Artist</span>
        <span className="info-separator">:</span>
        <span className="info-value">{song.artist}</span>
      </div>

      {/* Lyrics row */}
      <div className="info-row">
        <div className="info-icon-wrapper">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
          </svg>
        </div>
        <span className="info-label">Lyrics</span>
        <span className="info-separator">:</span>
        <span className="info-value">{song.lyrics}</span>
      </div>

      {/* Music row */}
      <div className="info-row">
        <div className="info-icon-wrapper">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18V5l12-2v13" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="18" cy="16" r="3" />
          </svg>
        </div>
        <span className="info-label">Music</span>
        <span className="info-separator">:</span>
        <span className="info-value">{song.music}</span>
      </div>

      {/* ISRC code row */}
      <div className="info-row">
        <div className="info-icon-wrapper isrc-wrapper">
          <span className="isrc-icon-text">ISRC</span>
        </div>
        <span className="info-label">ISRC code</span>
        <span className="info-separator">:</span>
        <span className="info-value">{song.isrcCode || 'None'}</span>
      </div>



      {/* Other Details row */}
      <div className="info-row">
        <div className="info-icon-wrapper">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="1" />
            <circle cx="5" cy="12" r="1" />
            <circle cx="19" cy="12" r="1" />
          </svg>
        </div>
        <span className="info-label">Other Details</span>
        <span className="info-separator">:</span>
        <span className="info-value">{song.other || 'None'}</span>
      </div>
    </div>
  );
}

export default BasicDetailsTab;
